'use client';

import { pushToDataLayer } from '@/components/analytics/ga-core';
import { postTermConsent } from '@/features/term/api/postTermConsent';
import { swal } from '@/lib/sweetalert';
import { type PendingReconsentTerm, RequiredConsentFlow, pickErrorMessages } from '@monorepo/common';

export type RequiredConsentProps = {
  /** 表示中のユーザーのID。抑制の記録・解除をユーザーごとに行うために使う */
  userId: number | undefined;
  /** `GET /term-consent/pending` の terms */
  terms: PendingReconsentTerm[];
  /** 全文書の表示が終わったときに呼ばれる。isAllAgreed が true のときだけ遷移を続行してよい */
  onFinished?: (isAllAgreed: boolean) => void;
  /** キャンセル時に訪問時モーダル（表示層①）を24時間抑制するか */
  suppressOnCancel?: boolean;
};

/**
 * 再承諾モーダル。
 * 共通の連続表示フローに、OEM 固有の同意登録 API・エラー表示・GA 送信を注入する。
 */
function RequiredConsent({ userId, terms, onFinished, suppressOnCancel }: RequiredConsentProps) {
  const handleAgree = async (oemTermId: number) => {
    // API は配列受けのため、文書ごとに要素1の配列で送信する
    await postTermConsent({ oemTermIds: [oemTermId] });
  };

  const handleError = (error: unknown) => {
    void swal.messages({ messages: pickErrorMessages(error) });
  };

  const pushDataLayer = (data: Record<string, unknown>) => {
    const { event, ...params } = data as { event: string } & Record<string, unknown>;
    pushToDataLayer(event, params);
  };

  return (
    <RequiredConsentFlow
      userId={userId}
      terms={terms}
      onAgree={handleAgree}
      onFinished={onFinished}
      onError={handleError}
      pushDataLayer={pushDataLayer}
      suppressOnCancel={suppressOnCancel}
      variant='raffle'
    />
  );
}

export default RequiredConsent;
